var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FB3836"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H11.3333H22",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 12.0002V10.6668C13.3333 10.3132 13.4738 9.97407 13.7239 9.72402C13.9739 9.47397 14.3131 9.3335 14.6667 9.3335H17.3333C17.687 9.3335 18.0261 9.47397 18.2762 9.72402C18.5262 9.97407 18.6667 10.3132 18.6667 10.6668V12.0002M20.6667 12.0002V21.3335C20.6667 21.6871 20.5262 22.0263 20.2762 22.2763C20.0261 22.5264 19.687 22.6668 19.3333 22.6668H12.6667C12.3131 22.6668 11.9739 22.5264 11.7239 22.2763C11.4738 22.0263 11.3333 21.6871 11.3333 21.3335V12.0002H20.6667Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 15.3335V19.3335",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 15.3335V19.3335",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashB);
export default __webpack_public_path__ + "static/media/trash_b.f76cca9bff004a836ba7b107c60c22d5.svg";
export { ForwardRef as ReactComponent };